module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }